import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={11} height={8} viewBox="0 0 11 8" fill="none" {...props}>
        <Path
            d="M1.17 5.632c.274.248.582.5.94.726a5.66 5.66 0 003.072.912 5.654 5.654 0 003.081-.913c.362-.23.679-.484.952-.732.449-.417.779-.829.998-1.136a.815.815 0 000-.974 7.56 7.56 0 00-1-1.138l-.002.003a6.524 6.524 0 00-.95-.735l-.009-.003A5.627 5.627 0 005.18.73a5.71 5.71 0 00-3.072.916c-.355.23-.666.477-.939.726-.449.417-.788.832-1.008 1.14a.825.825 0 000 .98c.224.304.56.722 1.01 1.14z"
            fill={designSystem.colors.liliac}
        />
    </Svg>
);
export default SvgComponent;
